import { get, post } from './fetcher';
import { API_BASE_URL } from '../config/api-config';

const SUPPLY = '/api/admin/supply';

// ===== 지역 =====
export const getSido = async (token) => {
  const res = await get(`${SUPPLY}/sido`, {}, token);
  if (res?.success) return res.data || [];
  throw new Error(res?.message || '시도 조회에 실패했습니다.');
};

export const getSigungu = async (token, sido) => {
  const res = await get(`${SUPPLY}/sigungu`, { sido }, token);
  if (res?.success) return res.data || [];
  throw new Error(res?.message || '시군구 조회에 실패했습니다.');
};

export const getLastSync = async (token) => {
  const res = await get(`${SUPPLY}/last-sync`, {}, token);
  if (res?.success) return res.data || {};
  throw new Error(res?.message || '마지막 동기화 조회 실패');
};

// ===== 조회 =====
export const querySupply = async (token, { sido, sigungu, start, end }) => {
  const res = await get(`${SUPPLY}/query`, { sido, sigungu, start, end }, token);
  if (res?.success) return res.data || { ok: true, presale: [], movein: [] };
  throw new Error(res?.message || '공급 조회에 실패했습니다.');
};

export const queryPlanned = async (token, { sido, sigungu, sort, all }) => {
  const res = await get(`${SUPPLY}/planned`, { sido, sigungu, sort, all: all ? 1 : 0 }, token);
  if (res?.success) return res.data || { ok: true, rows: [] };
  throw new Error(res?.message || '분양예정 조회에 실패했습니다.');
};

// ===== 분양예정 저장 =====
export const addManualPlanned = async (token, payload) => {
  const res = await post(`${SUPPLY}/planned`, payload, token);
  return { ok: !!res?.success, message: res?.message, count: res?.data?.count || 0 };
};

// CSV 업로드 (multipart) — fetcher는 JSON 강제라 raw fetch 사용
export const uploadCsv = async (token, file) => {
  const form = new FormData();
  form.append('file', file);
  const res = await fetch(`${API_BASE_URL}${SUPPLY}/planned/upload`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: form,
  });
  const data = await res.json();
  return { ok: !!data?.success, message: data?.message, result: data?.data };
};

// ===== 동기화 =====
export const loadSync = async (token, sido) => {
  const res = await post(`${SUPPLY}/sync/load`, { sido }, token);
  return { ok: !!res?.success, message: res?.message, rows: res?.data?.rows || [] };
};

export const startSync = async (token, { timeout, delay }) => {
  const res = await post(`${SUPPLY}/sync/start`, { timeout, delay }, token);
  return { ok: !!res?.success, message: res?.message };
};

export const stopSync = async (token) => {
  const res = await post(`${SUPPLY}/sync/stop`, {}, token);
  return { ok: !!res?.success, message: res?.message };
};

export const getSyncState = async (token) => {
  const res = await get(`${SUPPLY}/sync/state`, {}, token);
  if (res?.success) return res.data || { running: false, status: '', progressText: '', rows: [], logs: [] };
  throw new Error(res?.message || '동기화 상태 조회 실패');
};
